import { AxiosResponse } from 'axios'
import { useContext } from '@nuxtjs/composition-api'
import { NewsListResponse } from '../../contracts/api/QueryNews/QueryNews.Response'
import { CHECK_QUOTATION } from '../../../config/bitrix-endpoints'
import { HTTP_REST } from '../../../plugins/axios'

export async function checkQuotation(
  ctx: ReturnType<useContext> | undefined = undefined,
  id: number | undefined = undefined
): Promise<AxiosResponse<NewsListResponse>> {
  return await HTTP_REST(ctx).get(`${CHECK_QUOTATION}?quotationId=${id}`)
}
